import styled from 'styled-components'

import { BaseBlockProps } from '../../../../types/BaseBlockProps'
import { hideBlockAt, marginBreakpoints } from '../../../../utils/commonAttrs'
import { spacing } from '../../../../utils/ui/spacing'

export const CarouselContainer = styled.div<BaseBlockProps>`
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  padding: ${spacing('xs')} 0;
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    white 5%,
    white 95%,
    transparent 100%
  );

  & > div {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  ${({ marginBottom }) => marginBreakpoints({ marginBottom }, 0)}
  ${({ hiddenAt }) => hideBlockAt({ hiddenAt })}
`
